export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="lg:w-2/5 flex-shrink-0">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden w-full max-w-[480px] mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20inviting%20home%20theater%20atmosphere%2C%20cozy%20living%20room%20with%20large%20screen%20displaying%20abstract%20colorful%20visuals%2C%20soft%20ambient%20orange%20and%20gold%20lighting%2C%20comfortable%20modern%20interior%2C%20cinematic%20entertainment%20vibe%2C%20clean%20composition%2C%20no%20recognizable%20content%20on%20screen&width=960&height=720&seq=about-01-2026&orientation=landscape"
                alt="神马视频 - 您的专属在线影视平台"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:w-3/5">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
              关于神马视频
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                神马视频致力于为广大影视爱好者打造一个便捷、免费、高品质的在线观影平台。我们深度整合西瓜视频免费、菠萝视频、青青草视频等优质内容源，为用户提供最新电影、热播电视剧、经典老片及热门综艺的一站式观看体验。
              </p>
              <p>
                平台每日实时更新片源，确保您能第一时间观看到最新上线的影视内容。全高清1080P画质搭配智能缓冲技术，让观影过程流畅丝滑，告别卡顿等待。无需注册、无需付费，打开即看，真正实现影视自由。
              </p>
              <p>
                我们始终坚持以用户体验为核心，持续优化内容推荐算法，让每位影迷都能在神马视频找到属于自己的那份光影感动。
              </p>
            </div>
            <div className="flex flex-wrap gap-6 mt-7">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                  <i className="ri-shield-check-line text-primary-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">安全无毒</div>
                  <div className="text-xs text-foreground-500">纯净观影环境</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">极速加载</div>
                  <div className="text-xs text-foreground-500">智能缓冲技术</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center">
                  <i className="ri-device-line text-secondary-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">全端适配</div>
                  <div className="text-xs text-foreground-500">手机电脑平板</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}